// extracted by mini-css-extract-plugin
export default {"tagsHolder":"CSMTags_tagsHolder__8YqkZ","tag":"CSMTags_tag__m3abg","noTags":"CSMTags_noTags__96SV3"};